/* eslint-disable import/no-unresolved */
import 'swiper/css';

import { useEffect, useMemo, useRef } from 'react';
import cx from 'clsx';
import { useRouter } from 'next/router';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperClass } from 'swiper/types';
import { trackEvent } from '@kcd/event-tracker';

import type { OAISchema } from '~/types/openapi';

type Showcase = {
  code: OAISchema['ShowcaseResponse']['code'];
  name: OAISchema['ShowcaseResponse']['name'];
};

type Props = {
  showcases: Showcase[];
  selectedShowcaseCode: string;
  showcaseGroupName?: string;
  eventName?: string;
  onClickCode: (code: string) => void;
};

const ShowcaseGroupFilterList = ({
  showcases,
  selectedShowcaseCode,
  showcaseGroupName,
  eventName,
  onClickCode,
}: Props) => {
  const router = useRouter();
  const swiperRef = useRef<SwiperClass>();

  const activeIndex = useMemo(() => {
    const targetIndex = showcases?.findIndex(
      ({ code }) => code === selectedShowcaseCode,
    );
    return targetIndex > 0 ? targetIndex : 0;
  }, [selectedShowcaseCode, showcases]);

  useEffect(() => {
    swiperRef.current?.slideTo(activeIndex || 0);
  }, [activeIndex]);

  return (
    <div>
      <Swiper
        slidesPerView="auto"
        onInit={(ref) => {
          swiperRef.current = ref;
        }}
      >
        {showcases.map(({ code, name }, index) => {
          return (
            <SwiperSlide
              className={cx([
                'flex items-center !h-40 !w-auto px-12 py-6 rounded-[100px] border-solid border-02 typo-paragraph100-semibold cursor-pointer border-1',
                'ml-8 [&:first-of-type]:ml-20 [&:last-of-type]:mr-20',
                activeIndex === index && '!bg-secondary-heavy !text-inverse',
              ])}
              key={code}
              onClick={() => {
                if (eventName) {
                  trackEvent(eventName, {
                    placementName: showcaseGroupName,
                    showcaseName: name,
                    showcaseCode: code,
                  });
                }

                // 쇼케이스 그룹 탭 기본 이벤트
                trackEvent('clicked tab in 마켓/쇼케이스그룹', {
                  path: router.asPath,
                  name,
                  showcaseCode: code,
                  index,
                  placement: 'showcase',
                });

                onClickCode(code);
              }}
            >
              {name}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ShowcaseGroupFilterList;
